<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <article
    :class="b()"
    role="button"
    tabindex="0"
    @click="handleRow"
    @keydown.enter="handleRow"
    @keydown.space.prevent="handleRow"
  >
    <div :class="b('date')">
      <strong>{{ displayedDate }}</strong>
      <span>{{ displayedTime }} · №{{ row.id }}</span>
    </div>

    <div :class="b('content')">
      <div :class="b('exchange')">
        <span :class="b('amount', { from: true })">{{
          displayedAmountFrom
        }}</span>
        <span :class="b('currency')">{{ displayedCurrencyFrom }}</span>
        <span :class="b('arrow')" aria-hidden="true">→</span>
        <span :class="b('amount', { to: true })">{{ displayedAmountTo }}</span>
        <span :class="b('currency')">{{ displayedCurrencyTo }}</span>
      </div>

      <p :class="b('details')">
        <span
          >{{ $t("Курс") }} <b>{{ displayedExecutionPrice }}</b>
          {{ displayedPair }}</span
        >
        <i aria-hidden="true"></i>
        <span
          >{{ $t("Объем") }} <b>{{ displayedTransactionVolume }}</b>
          {{ displayedCurrencyTo }}</span
        >
        <i aria-hidden="true"></i>
        <span
          >{{ $t("Комиссия") }} <b>{{ displayedCommission }}</b>
          {{ displayedCommissionCurrency }}</span
        >
      </p>

      <div :class="b('stage')">
        <span>{{ $t("Текущий этап") }}</span>
        <p>{{ displayedStage }}</p>
      </div>
    </div>

    <span :class="b('status', { tone: displayedStatusTone })">
      <i></i>
      {{ $t(displayedStatus) }}
    </span>

    <button
      v-if="isRemoveShow"
      :class="b('remove')"
      :aria-label="$t('Удалить')"
      @click.stop="handleRemove"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M6 7h12m-8 4v5m4-5v5M9 7l1-2h4l1 2m-8 0 1 13h8l1-13" />
      </svg>
    </button>
  </article>
</template>
